import '../styles/styles.scss';
import attribution from '../frontend/modules/attribution';

attribution();
